import React from 'react'
import PropTypes from 'prop-types'

const WithData = (mapDataToProps, Component) => {
  return props => {
    const newProps = Object.assign({}, props, mapDataToProps(props.data))
    return <Component {...newProps} />
  }
}

WithData.propTypes = {
  mapDataToProps: PropTypes.func.isRequired,
  Component: PropTypes.func.isRequired,
}

export default WithData



// WEBPACK FOOTER //
// ./src/components/common/with-data.js